import React from "react";
import { Button, Modal, Toast, Badge, Icon } from "antd-mobile";
import { post } from "../../utils/request";
import { href } from "../../utils/util";
import imgUrl from "./images/quan.png";

import "./index.less";
import { wxfx } from "../../utils/wxfx.js";

class InviteNewUsersDownload extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
        };
    }

    // #/inviteNewUsers?app_stoken=xxxx&
    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    this.fx();
                }
            );
        }
    }

    fx() {
        const { urlOps } = this.state;
        wxfx({
            title: "注册远程慧联app即可获得5元充电券",
            imgUrl: "https://static.hellogil.com/oss-prod-unsafe-group/statics/6a8009d8063148ccb0ec9b39b02f41b3.png",
            desc: `充电券免费送，邀请越多奖励越多，还有机会瓜分千元充电大礼包。`,
            url: `https://www.hellogil.com/payment/#/inviteNewUsersShare?lastNumber=${urlOps.lastNumber}&inviteCode=${urlOps.inviteCode}`, //`${window.location.origin}${window.location.pathname}#/inviteNewUsersShare?lastNumber=${urlOps.lastNumber}&inviteCode=${urlOps.inviteCode}`
        });
    }

    render() {
        const { modalType } = this.state;
        return (
            <div className="InviteNewUsersDownloadBox">
                <img src={imgUrl} />
                <div>
                    <h2>优惠券领取成功</h2>
                    <p>下载远程慧联APP立即使用</p>
                </div>
                <a
                    onClick={() => {
                        window.location.href =
                            "https://www.hellogil.com/appDownload/#/HuilianDownload";
                    }}
                >
                    下载远程慧联APP
                </a>
            </div>
        );
    }
}

export default InviteNewUsersDownload;



// WEBPACK FOOTER //
// ./src/inviteNewUsers/download/index.js